var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1716_800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9991 3.34136C27.9446 3.80297 26.797 4.13519 25.615 4.26458C26.8422 3.52473 27.7612 2.35588 28.1996 0.977344C27.048 1.67252 25.7865 2.15999 24.4709 2.41813C23.9211 1.82163 23.2561 1.34642 22.5173 1.02213C21.7786 0.697842 20.982 0.531413 20.1771 0.533218C16.9206 0.533218 14.3015 3.21197 14.3015 6.4992C14.3015 6.96081 14.3567 7.42243 14.4463 7.86655C9.57006 7.60777 5.2211 5.24376 2.32984 1.6243C1.80302 2.53744 1.52695 3.57715 1.53035 4.63527C1.53035 6.70553 2.56762 8.53099 4.14937 9.60459C3.21722 9.56734 2.3069 9.30733 1.49244 8.84573V8.91917C1.49244 11.8182 3.51185 14.2207 6.20324 14.7732C5.6979 14.9064 5.17805 14.9746 4.65594 14.9761C4.27343 14.9761 3.91159 14.9376 3.54631 14.8852C4.29066 17.2492 6.45825 18.9662 9.03936 19.0222C7.01996 20.6273 4.49053 21.5715 1.744 21.5715C1.25122 21.5715 0.796332 21.554 0.324219 21.4981C2.92946 23.1942 6.02059 24.1733 9.34951 24.1733C20.1564 24.1733 26.0699 15.088 26.0699 7.20211C26.0699 6.94333 26.0699 6.68455 26.0527 6.42576C27.1968 5.57598 28.1996 4.52336 28.9991 3.34136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1716_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7059,
    height: 23.6401,
    fill: "white",
    transform: "translate(0.292969 0.533203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/X-logo.b44551b6aed3a6030800d9241bd28d65.svg";
export { ForwardRef as ReactComponent };